var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lead-wrapper"},[_c('div',{staticClass:"content row gap"},[_c('div',{staticClass:"image col-xs-12 col-sm-4"},[_c('img',{attrs:{"src":_vm.image,"alt":""}})]),_c('div',{staticClass:"content col-xs-12 col-sm-8"},[_c('h3',[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"bio",domProps:{"innerHTML":_vm._s(_vm.bio)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }